import _ from 'underscore'
// import Logger from 'Logger'

/**
 * @return {SelectedGoods}
 */
export function getSelectedGoods() {
  var goodsCount = 0
  var gameMoney = 0
  var goodsPrice = 0
  _.each(this.models, function (model) {
    if (model.get('isChecked')) {
      goodsCount += 1
      gameMoney += model.get('reward_money')
      goodsPrice += model.get('goods_price')
    }
  })
  return {
    goodsCount: goodsCount || 0,
    gameMoney: gameMoney || 0,
    goodsPrice: goodsPrice || 0,
  }
}
/**
 * [collection] :  컬랙션에 어리트뷰트 추가 / 뷰 카테고리 구분용
 * @param {Array} list
 * @param {Object} newAttr
 */
export function addAttribute(list, newAttr) {
  if (!list) return []
  var newLists = _.map(list, function (item) {
    var attrAdded = _.extend(item, newAttr)
    return attrAdded
  })
  return newLists
}

/**
 * [collection] : 선택된 아이템 초기화
 */

export function resetSelectedGoods() {
  _.each(this.models, function (model) {
    model.set({
      isChecked: false,
    })
  })
}
